import {LANGUAGE} from '@/common/utils/constants';

export const CATEGORY_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		title: {
			industries: "Industries",
			serviceLines: "Type of Business",
			techPractices: "Tech Practices",
			akkodisResearch: "Akkodis Research"
		},
		description: {
			industries: "Here are the industries where Akkodis operates, including the seven key global industries, part of" +
				" the Global 7 x 7 x 4 Strategy:",
			serviceLines: "As a global Smart Industry leader, we partner with clients through our four types of Business, across " +
				"clients’ widest range of needs: from talent management and training, consulting, and " +
				"solutions to complete project execution:",
			techPractices: "Below is Akkodis’ technological expertise which cuts across several or all of the key industries, " +
				"part of the Global 7 x 7 x 4 Strategy:",
			akkodisResearch: "Leveraging our extensive academic and industrial network, we work with emerging " +
				"technologies to help our clients keep innovating now and in the future:"
		},
		card: {
			projects: "Projects",
			viewProjects: "View projects"
		}
	},
	[LANGUAGE.de.short]: {
		title: {
			industries: "Branchen",
			serviceLines: "Geschäftsart",
			techPractices: "Tech-Praktiken",
			akkodisResearch: "Akkodis-Forschung"
		},
		description: {
			industries: "Hier sind die Branchen aufgeführt, in denen Akkodis tätig ist, einschließlich der" +
				" sieben globalen Schlüsselindustrien, die Teil der globalen 7 x 7 x 4-Strategie sind:",
			serviceLines: "Als weltweit führendes Unternehmen im Bereich Smart Industry arbeiten wir mit unseren Kunden in " +
				"vier verschiedenen Geschäftsbereichen zusammen und decken dabei ein breites Spektrum an Bedürfnissen ab: von " +
				"Talentmanagement und -entwicklung über Beratung und Lösungen bis hin zur kompletten Projektabwicklung.",
			techPractices: "Nachfolgend ist das technologische Know-how von Akkodis aufgeführt, das sich über mehrere oder " +
				"alle Schlüsselindustrien erstreckt und Teil der globalen 7 x 7 x 4-Strategie ist:",
			akkodisResearch: "Wir nutzen unser umfangreiches akademisches und industrielles Netzwerk und " +
				"arbeiten mit neuen Technologien, um unseren Kunden zu helfen, jetzt und in Zukunft innovativ zu bleiben:"
		},
		card: {
			projects: "Projekte",
			viewProjects: "Projekte anzeigen"
		}
	},
	[LANGUAGE.fr.short]: {
		title: {
			industries: "Les industries",
			serviceLines: "Type d'activité",
			techPractices: "Pratiques techniques",
			akkodisResearch: "Recherche d'Akkodis"
		},
		description: {
			industries: "Voici les industries dans lesquelles Akkodis opère, y compris les sept industries mondiales clés, " +
				"qui font partie de la stratégie mondiale 7 x 7 x 4 :",
			serviceLines: "En tant que leader mondial de l'industrie intelligente, nous collaborons avec nos clients à travers" +
				" nos quatre types d'activités, couvrant ainsi un large éventail de besoins: de la gestion des talents et la " +
				"formation au conseil et aux solutions, jusqu'à la réalisation complète de projets.",
			techPractices: "Vous trouverez ci-dessous l'expertise technologique d'Akkodis qui couvre plusieurs ou " +
				"toutes les industries clés, dans le cadre de la stratégie mondiale 7 x 7 x 4 :",
			akkodisResearch: "Tirant parti de notre vaste réseau académique et industriel, nous travaillons avec" +
				" les technologies émergentes pour aider nos clients à continuer d'innover aujourd'hui et à l'avenir:"
		},
		card: {
			projects: "Projets",
			viewProjects: "Voir les projets"
		}
	},
	[LANGUAGE.it.short]: {
		title: {
			industries: "Industrie",
			serviceLines: "Tipologia di attività",
			techPractices: "Pratiche tecniche",
			akkodisResearch: "Ricerca Akkodis"
		},
		description: {
			industries: "Ecco i settori in cui opera Akkodis, inclusi i sette settori chiave globali, che fanno parte della " +
				"strategia globale 7 x 7 x 4:",
			serviceLines: "In qualità di leader globale nel settore Smart Industry, collaboriamo con i clienti attraverso " +
				"quattro tipologie di attività, per soddisfare la più ampia gamma di esigenze: dalla gestione dei talenti e " +
				"formazione, alla consulenza e alle soluzioni, fino all'esecuzione completa dei progetti:",
			techPractices: "Di seguito è riportata l'esperienza tecnologica di Akkodis che interessa diversi o tutti i " +
				"settori chiave, parte della strategia globale 7 x 7 x 4:",
			akkodisResearch: "Sfruttando la nostra vasta rete accademica e industriale, lavoriamo con tecnologie " +
				"emergenti per aiutare i nostri clienti a continuare a innovare ora e in futuro:"
		},
		card: {
			projects: "Progetti",
			viewProjects: "Visualizza progetti"
		}
	},
	[LANGUAGE.ja.short]: {
		title: {
			industries: "産業",
			serviceLines: "事業の種類",
			techPractices: "技術の実践",
			akkodisResearch: "アッコディス研究"
		},
		description: {
			industries: "以下は、グローバル 7 x 7 x 4 戦略の一部である 7 つの主要なグローバル産業を含む、Akkodis が事業を行っている産業です:",
			serviceLines: "グローバルなスマートインダストリーのリーダーとして、私たちは4つの事業分野を通じてお客様と提携し、人材管理・研修、コンサル" +
				"ティング、ソリューション提供からプロジェクト遂行まで、お客様の幅広いニーズにお応えします。",
			techPractices: "以下は、グローバル 7 x 7 x 4 戦略の一部である主要産業のいくつかまたはすべてにまたがる Akkodis の技術的専門知識です:",
			akkodisResearch: "広範な学術および産業ネットワークを活用して、私たちはクライアントが現在および将来にわたって革新を続ける" +
				"のを支援するために、新しいテクノロジーと協力しています:"
		},
		card: {
			projects: "プロジェクト",
			viewProjects: "プロジェクトを見る"
		}
	},
	[LANGUAGE.es.short]:{
		title: {
			industries: "Industrias",
			serviceLines: "Tipo de Negocio",
			techPractices: "Prácticas tecnológicas",
			akkodisResearch: "Investigación de Akkodis"
		},
		description: {
			industries: "Aquí están las industrias en las que opera Akkodis, incluidas las siete industrias clave a nivel mundial, que forman parte de la estrategia global 7 x 7 x 4:",
			serviceLines: "Como líder global en la Industria Inteligente, colaboramos con nuestros clientes a través de nuestros " +
				"cuatro tipos de Negocio, cubriendo sus necesidades más diversas: " +
				"desde la gestión y capacitación del talento, la consultoría y las soluciones hasta la ejecución completa de proyectos.",
			techPractices: "A continuación se presenta la experiencia tecnológica de Akkodis que abarca varias o todas las industrias clave, parte de la estrategia global 7 x 7 x 4:",
			akkodisResearch: "Aprovechando nuestra amplia red académica e industrial, trabajamos con tecnologías emergentes para ayudar a nuestros clientes a seguir innovando ahora y en el futuro:"
		},
		card: {
			projects: "Proyectos",
			viewProjects: "Ver proyectos"
		}
	}
}
